import { FilterConfig } from '../interfaces/FilterConfig';

export const parseFilterConfig = (config: string): FilterConfig => {
  return JSON.parse(config);
};
